import React from "react";
import PT from "prop-types";

import "./hamburger-menu.m.css";
import HamburgerSearch from "../../../../atoms/other-icons/HamburgerSearch";

export const CustomHamburgerMenu = ({ onMenuToggle, isMegaMenuOpen, isMobileHamburger }) => (
  <button
    aria-label="Hamburger Menu"
    className="hamburger-menu"
    onClick={onMenuToggle}
    styleName={`hamburger ${isMegaMenuOpen ? "is-open" : ""}`}
  >
    <HamburgerSearch color="white" width="30" height="20" />
  </button>
);

CustomHamburgerMenu.propTypes = {
  onMenuToggle: PT.func,
  isMegaMenuOpen: PT.bool,
  isMobileHamburger: PT.bool
};

export default CustomHamburgerMenu;
